var _style, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodWayStarTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsLink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 355 363",
    style: {
      enableBackground: "new 0 0 355 363"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "&ns_ai;",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("iAipgfRef", {
    xlinkHref: "#adobe_illustrator_pgf"
  })), /*#__PURE__*/React.createElement("g", {
    iExtraneous: "self"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.58,135.18l4.43,13.11c0.49,1.44,2.26,1.94,3.43,0.97l10.63-8.87c1.65-1.38,4.08,0.24,3.44,2.3 l-4.12,13.22c-0.45,1.45,0.69,2.9,2.2,2.8l13.81-0.93c2.15-0.14,3.16,2.6,1.43,3.88l-11.1,8.27c-1.22,0.91-1.14,2.75,0.14,3.56 l11.72,7.37c1.82,1.14,1.03,3.96-1.12,3.98l-13.84,0.17c-1.52,0.02-2.54,1.55-1.98,2.96l5.15,12.85c0.8,2-1.49,3.81-3.25,2.56 l-11.3-8c-1.24-0.88-2.97-0.24-3.34,1.23l-3.38,13.42c-0.53,2.09-3.45,2.2-4.14,0.16l-4.43-13.11c-0.49-1.44-2.26-1.94-3.43-0.97 l-10.63,8.87c-1.65,1.38-4.08-0.24-3.44-2.3l4.12-13.22c0.45-1.45-0.69-2.9-2.2-2.8l-13.81,0.93c-2.15,0.14-3.16-2.6-1.43-3.88 l11.1-8.27c1.22-0.91,1.14-2.75-0.14-3.56l-11.72-7.37c-1.82-1.14-1.03-3.96,1.12-3.98l13.84-0.17c1.52-0.02,2.54-1.55,1.98-2.96 l-5.15-12.85c-0.8-2,1.49-3.81,3.25-2.56l11.3,8c1.24,0.88,2.97,0.24,3.34-1.23l3.38-13.42 C176.97,133.26,179.9,133.14,180.58,135.18z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodWayStarTest);
export default __webpack_public_path__ + "static/media/good_way_star_test.9cbf8f39eeacb0bebba9a9c35906e3b0.svg";
export { ForwardRef as ReactComponent };